import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'period-picker-calendar-header',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PeriodPickerCalendarHeaderComponent {
}
